var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.49984V13.9998C1.5 15.8408 2.99238 17.3332 4.83333 17.3332H13.1667C15.0076 17.3332 16.5 15.8408 16.5 13.9998V6.49984M1.5 6.49984V5.24984C1.5 3.40889 2.99238 1.9165 4.83333 1.9165H13.1667C15.0076 1.9165 16.5 3.40889 16.5 5.24984V6.49984M1.5 6.49984H16.5M12.3333 0.666504V3.1665M5.66667 0.666504V3.1665",
    stroke: "#A4A8B5",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIco);
export default __webpack_public_path__ + "static/media/events-ico.decdb9c3660a9217ac794d911ee480e9.svg";
export { ForwardRef as ReactComponent };